$w.onReady(function () {
    //TODO: write your page related code here...

});

let fadeOptions = {
    "duration": 200,
    "delay": 0
};

export function oneInboxVideoCta_click(event) {
    $w('#oneInboxVideoCta').hide()
        .then(() => $w('#oneInboxVideoCover').hide('fade', fadeOptions))
        .then(() => $w('#oneInboxVideo').show('fade', fadeOptions))
        .then(() => $w('#oneInboxVideo').play())
}